import React from 'react'
import styled from 'styled-components'
import Lottie from 'lottie-react'
import {isMobile} from 'react-device-detect';

import LoaderData from  './loader.json'
import {mapMyStyles} from "View/helper";

const themeStyle = mapMyStyles('lobby_networkLoader')
const BackgroundOpacity=styled.div`
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height:100vh;
    opacity: ${props => props.fullOpacity ? 1 : 0.8};
    background-color: ${themeStyle.bgColor};
    z-index:11;
`

const Wrapper=styled.div`
    position:absolute;
    left:0;
    right:0;
    top:0;
    bottom:0;
    opacity:1;
    margin:auto;
    width:25em;
    height:23em;
    z-index:12;
`

const Div=styled.div`
    width:20em;
    height:20em;
    position:absolute;
    left:0;
    right:0;
    top:0;
    bottom:0;
    margin:auto;
`

function NetworkLoader(props){
    let loaderStyle={};
    if (isMobile) {
        loaderStyle = {width : "60%", height : "60%" , transform: "translate3d(26%, 31%, 0px)"}
    }
    return(
        <>
        <BackgroundOpacity fullOpacity={props.fullOpacity} />
        <Wrapper>
            <Div>
                <Lottie style={loaderStyle} animationData={LoaderData}/>
            </Div>
        </Wrapper>
    </>
    )
}
export default NetworkLoader;
